export default "__VITE_ASSET__C2379PKI__"